import Sidebar from "../../../components/sidebar/Sidebar"
import Navbar from "../../../components/navbar/Navbar"
import "../../Patient/list.scss"
import DepartmentList from "./departmentList"

const DepartmentListContainer = () => {

 
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <>
        <DepartmentList  />
        </>
      </div>
    </div>
  )
}

export default DepartmentListContainer